/**
 * GlobalView — Rejected / Suspended Page
 *
 * Shown to users with status REJECTED or SUSPENDED (§25).
 */

import { useAuthStore } from '../stores/authStore';

export default function RejectedPage() {
  const signOut = useAuthStore((s) => s.signOut);
  const userStatus = useAuthStore((s) => s.userStatus);

  const isRejected = userStatus === 'rejected';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
    }}>
      <div style={{
        background: 'var(--glass-bg)',
        border: '1px solid var(--glass-border)',
        backdropFilter: 'blur(var(--glass-blur))',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-8) var(--space-6)',
        maxWidth: '440px',
        textAlign: 'center',
      }}>
        <div style={{
          fontSize: '3rem',
          marginBottom: 'var(--space-4)',
        }}>
          {isRejected ? '🚫' : '⏸️'}
        </div>

        <h1 style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 'var(--text-xl)',
          color: 'var(--accent3)',
          letterSpacing: '0.05em',
          marginBottom: 'var(--space-4)',
        }}>
          {isRejected ? 'Zugang abgelehnt' : 'Konto gesperrt'}
        </h1>

        <p style={{
          color: 'var(--text-dim)',
          fontSize: 'var(--text-base)',
          lineHeight: '1.7',
          marginBottom: 'var(--space-6)',
        }}>
          {isRejected
            ? 'Ihr Zugangsantrag wurde abgelehnt. Bei Fragen wenden Sie sich an den Administrator.'
            : 'Ihr Konto wurde vorübergehend gesperrt. Bitte kontaktieren Sie den Administrator.'}
        </p>

        <button
          onClick={signOut}
          id="rejected-sign-out"
          style={{
            padding: 'var(--space-2) var(--space-5)',
            background: 'transparent',
            border: '1px solid var(--glass-border)',
            borderRadius: 'var(--radius-md)',
            color: 'var(--text-dim)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-sm)',
            cursor: 'pointer',
          }}
        >
          Abmelden
        </button>
      </div>
    </div>
  );
}
